import axios from 'axios'
import {resetAuth, setAuth} from './../../utils/auth'
import {API_SERVER, BASE_URL, AUTHORIZATION} from './../../constants/constants'

const state = {
  user: null,
  currentToken: localStorage.getItem(AUTHORIZATION)
}
const mutations = {
  setAuth (state, data) {
    state.currentToken = data
  },
  setUser (state, data) {
    state.user = data
  },
  resetUser (state) {
    state.user = null
    state.currentToken = null
  }
}
const actions = {
  async fetch ({commit, dispatch}, param) {
    if (!param) {
      return
    }
    let {data} = await axios({
      url: 'member/fetch-me',
      headers: {'X-AUTH-TOKEN': param},
      baseURL: API_SERVER + BASE_URL
    })
    if (data && data.status === 200) {
      const user = {
        firstName: data.firstName,
        lastName: data.lastName
      }
      commit('setUser', user)
      commit('setAuth', param)
      setAuth(param)
    } else {
      dispatch('resetAuth')
    }
    return data.status
  },
  login ({commit}, param) {
    return axios.post('auth/login', param)
      .then(response => {
        const {data} = response
        if (data && data.status === 200) {
          commit('setAuth', data.data.token)
          setAuth(data.data.token)
        }
        return response
      })
  },
  logout ({commit}) {
    return axios.get('auth/logout')
      .then(response => {
        return response.data.status
      })
  },
  resetAuth ({commit}) {
    commit('resetUser')
    resetAuth()
  }
}
const getters = {
  currentToken: (state) => {
    return state.currentToken
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js